import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NUMBER_OF_SECONDS_BETWEEN_UPDATES, TYPE_TRANSLATION } from 'researcher/digital-orders/constants';
import useRepeater from 'researcher/hooks/use-repeater';
import Paginator from 'shared/components/Paginator';
import DigitalTranslationStatus from './DigitalTranslationStatus';
import DigitalTranslationsActions from './DigitalTranslationsActions';
var DigitalTranslationsResults = function DigitalTranslationsResults(_ref) {
  var digitalTranslations = _ref.digitalTranslations,
    getDownloadUrl = _ref.getDownloadUrl,
    pagination = _ref.pagination,
    paginationUrl = _ref.paginationUrl,
    searchDigitalOrders = _ref.searchDigitalOrders,
    status = _ref.status,
    updateDisplayedDigitalOrders = _ref.updateDisplayedDigitalOrders;
  var downloading = function downloading(digitalTranslation) {
    return status.retrievingDownload && status.downloadingFiles.indexOf(digitalTranslation.identity) >= 0;
  };
  var inProgressDigitalTranslationIdentities = digitalTranslations.filter(function (digitalTranslation) {
    return digitalTranslation.processing;
  }).map(function (digitalTranslation) {
    return digitalTranslation.identity;
  });
  var _useRepeater = useRepeater({
      fn: function fn() {
        return updateDisplayedDigitalOrders({
          identities: inProgressDigitalTranslationIdentities,
          type: TYPE_TRANSLATION
        });
      },
      numberOfSecondsBetweenCalls: NUMBER_OF_SECONDS_BETWEEN_UPDATES
    }),
    startUpdating = _useRepeater.start,
    stopUpdating = _useRepeater.stop;
  useEffect(function () {
    if (inProgressDigitalTranslationIdentities.length > 0) {
      startUpdating();
    } else {
      stopUpdating();
    }
  }, [inProgressDigitalTranslationIdentities.length]);
  useEffect(function () {
    return function () {
      return stopUpdating();
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, digitalTranslations.map(function (digitalTranslation) {
    return /*#__PURE__*/React.createElement("div", {
      className: "digital-translation clearfix p-3",
      key: digitalTranslation.identity
    }, /*#__PURE__*/React.createElement("div", {
      className: "float-start progress-circle"
    }, /*#__PURE__*/React.createElement(DigitalTranslationStatus, {
      digitalTranslation: digitalTranslation
    })), /*#__PURE__*/React.createElement("div", {
      className: "content ps-3 pt-2 mb-0"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "text-truncate"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "me-2 align-middle",
      icon: "fa-solid fa-file-lines"
    }), digitalTranslation.file.name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-muted mt-1 text-small"
    }, /*#__PURE__*/React.createElement(DigitalTranslationsActions, {
      digitalTranslation: digitalTranslation,
      downloading: downloading,
      getDownloadUrl: getDownloadUrl
    })))));
  }), /*#__PURE__*/React.createElement(Paginator, {
    className: "pt-3",
    pagination: pagination,
    url: paginationUrl,
    onPageChange: function onPageChange(page) {
      return searchDigitalOrders({
        page: page,
        type: TYPE_TRANSLATION
      }).then(function () {
        return window.scrollTo(0, 0);
      });
    },
    updating: status.searchBusy
  }));
};
export default DigitalTranslationsResults;